import React, { useRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

interface Props {
  buttonProps?: ButtonProps;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  file?: File;
  // eslint-disable-next-line no-unused-vars
  setFile: (file: File | undefined) => void;
}

// This component allows users to upload a file
// and stores the file in the component's state.
export default function FileButton(props: Readonly<Props>) {
  const { buttonProps = {}, inputProps = {}, file, setFile } = props;

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick = () => fileInputRef?.current?.click();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setFile(event.target.files?.[0]);

  return (
    <>
      <Button {...buttonProps} onClick={handleButtonClick}>
        {file?.name ?? 'Upload File'}
      </Button>
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        {...inputProps}
      />
    </>
  );
}
